import React from 'react';

const TOPICS = ['דף יומי', 'הרמב"ם היומי', '929'];

function formatLearningValue(value = '') {
  if (!value) {
    return '';
  }

  const withoutBracket = value.includes('(') ? value.slice(0, value.indexOf('(')) : value;
  return withoutBracket.replaceAll(':', ', ').replaceAll('-', ' - ').replaceAll('סדר ', '').trim();
}

function LearningRow({ value }) {
  return (
    <div className="detail container panel-row panel-item panel-item--learning" style={{ textAlign: 'start' }}>
      {value}
    </div>
  );
}

function LearningPanel({ learn, loading }) {
  const items = TOPICS.map((topic) => {
    const value = learn.find((item) => item.title?.he === topic)?.displayValue?.he;
    return formatLearningValue(value);
  });

  return (
    <div className="glass container panel-fit learning-panel" style={{ justifyContent: 'flex-start' }}>
      <h1>לימוד יומי</h1>
      <div className="panel-content panel-content-static">
        {loading && !items.some(Boolean) ? (
          <div className="panel-placeholder">טוען מידע...</div>
        ) : (
          items.map((value, index) => <LearningRow key={`${value}-${index}`} value={value} />)
        )}
      </div>
    </div>
  );
}

export default React.memo(LearningPanel);
